/** CMS `linkMeta.linkKey` / markdown `{{key}}` tokens resolved at render time. */
export enum TasklistDynamicLinkKey {
  CanvasLink = 'canvasLink',
  MyAccountLink = 'myAccountLink',
  K12ZoneLink = 'k12ZoneLink',
  CalendarLink = 'calendarLink',
  EnrollmentPortal = 'enrollmentPortal',
  CommunityUrl = 'communityUrl',
}

/** CMS `linkMeta.linkType` for structured buttons. */
export enum TasklistDynamicLinkType {
  ApiQuicklink = 'api-quicklink',
}

export interface TasklistPageLinkMeta {
  linkType?: TasklistDynamicLinkType;
  linkKey: TasklistDynamicLinkKey;
}

const LINK_KEY_VALUES = new Set<string>(Object.values(TasklistDynamicLinkKey));

export function isTasklistDynamicLinkKey(value: string): value is TasklistDynamicLinkKey {
  return LINK_KEY_VALUES.has(value);
}

export function parseTasklistDynamicLinkKey(value: string): TasklistDynamicLinkKey | null {
  const trimmed = value.trim();
  return isTasklistDynamicLinkKey(trimmed) ? trimmed : null;
}
